import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en/common.json';
import frTranslations from './locales/fr/common.json';
import esTranslations from './locales/es/common.json';

i18n
  .use(LanguageDetector) // Detects user language from browser
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: enTranslations,
      },
      fr: {
        translation: frTranslations,
      },
      es: {
        translation: esTranslations,
      },
    },
    fallbackLng: 'en', // Default language if detection fails
    debug: false, // Set to true for development debugging
    returnEmptyString: false, // Don't return empty string if translation missing
    returnNull: false, // Don't return null if translation missing
    keySeparator: '.', // Use dot as separator for nested keys
    nsSeparator: ':', // Use colon as namespace separator
    defaultNS: 'translation', // Default namespace
    react: {
      useSuspense: false, // Don't use suspense for translations
    },
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    // Custom handler to prevent objects from being returned (prevents React error #31)
    parseMissingKeyHandler: (key: string) => {
      // Return the key itself if translation is missing (not an object)
      return key;
    },
    detection: {
      // Order of language detection - URL query parameter first for SEO/crawling
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
      // Look for 'lang' in URL query string (e.g., ?lang=fr)
      lookupQuerystring: 'lang',
      // Cache user language preference
      caches: ['localStorage'],
      // Convert detected language to base code (e.g., 'fr-FR' -> 'fr')
      convertDetectedLanguage: (lng: string) => {
        return lng.split('-')[0];
      },
    },
  });

export default i18n;

